import React from 'react';
import { FormGroup, Input, InputGroup, InputGroupText } from 'reactstrap';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { FormLabel, toasty } from '../common/forms/FormElements';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import cls from 'classnames';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import { ServiceResponseResult } from '../Common';
import { MaxResourceCount } from './LongTermSchedule';

export default class AdditionalLaborJobResourceManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isValid: false,
            additionalLaborResources: [],
        };
    }

    isValid = (additionalLaborResources) =>
        additionalLaborResources.every(
            (jr) =>
                !isNaN(jr.count) && jr.count > 0 && jr.count < MaxResourceCount
        );

    onApplicationUserGroupSelectionChange = (
        applicationUserGroupSelections
    ) => {
        const { signalChange } = this.props;

        signalChange();

        let { additionalLaborResources } = this.state;

        additionalLaborResources = additionalLaborResources.filter((ajr) =>
            applicationUserGroupSelections.some(
                (aug) => ajr.applicationUserGroupId == aug.id
            )
        );

        const newApplicationUserGroup = applicationUserGroupSelections.find(
            (et) =>
                !additionalLaborResources.some(
                    (jr) => jr.applicationUserGroupId == et.id
                )
        );

        if (newApplicationUserGroup) {
            additionalLaborResources.push({
                applicationUserGroupId: newApplicationUserGroup.id,
                count: 0,
            });
        }

        this.setState({
            additionalLaborResources,
            isValid: this.isValid(additionalLaborResources),
        });
    };

    onCountChange = (dataContainer, e) => {
        const { signalChange } = this.props;

        signalChange();

        const { additionalLaborResources } = this.state;

        const { applicationUserGroupId } = dataContainer;

        additionalLaborResources.forEach((ajr) => {
            if (ajr.applicationUserGroupId != applicationUserGroupId) {
                return;
            }

            ajr.count = e.target.value;
        });

        this.setState({
            additionalLaborResources,
            isValid: this.isValid(additionalLaborResources),
        });
    };

    getEventDisplayDate = () => {
        const { eventDate } = this.props;

        return !eventDate
            ? null
            : moment(eventDate).format(MomentDateFormat.WeekDayNameAndDate);
    };

    onSaveAdditionalLaborResources = async () => {
        const { job, eventDate, onResourcesUpdated } = this.props;

        const { isSaving, isValid, additionalLaborResources } = this.state;

        if (
            isSaving ||
            !isValid ||
            !additionalLaborResources ||
            !additionalLaborResources.length ||
            !job ||
            !eventDate ||
            !onResourcesUpdated ||
            !this.isValid(additionalLaborResources)
        ) {
            return;
        }

        this.setState({ isSaving: true });

        const response = await util.fetch.andGetResponse(
            util.fetch.types.post,
            ApiRoutes.job.addAdditionalLaborResources(),
            {
                jobId: job.id,
                eventDate,
                additionalLaborResources,
            },
            'Error Adding Labor Resources'
        );

        if (response.result === ServiceResponseResult.Ok) {
            toasty.success('Labor resources updated.');

            onResourcesUpdated();

            this.setState({
                additionalLaborResources: [],
            });
        } else {
            toasty.error('Problem saving the job:', response.message, {
                autoClose: false,
                closeOnClick: true,
            });
        }

        this.setState({ isSaving: false });
    };

    componentDidUpdate(prevProps) {
        const { saving } = this.props;

        if (saving) {
            this.onSaveAdditionalLaborResources();
        }
    }

    render() {
        const { job, eventDate, applicationUserGroups } = this.props;

        const { additionalLaborResources } = this.state;

        applicationUserGroups.sort((a, b) =>
            a.groupName < b.groupName ? -1 : 1
        );

        additionalLaborResources.sort((a, b) => {
            const applicationUserGroupA = applicationUserGroups.find(
                (et) => et.id == a.applicationUserGroupId
            );

            const applicationUserGroupB = applicationUserGroups.find(
                (et) => et.id == b.applicationUserGroupId
            );

            return applicationUserGroupA.groupName <
                applicationUserGroupB.groupName
                ? -1
                : 1;
        });

        if (!job || !eventDate || !applicationUserGroups) {
            return null;
        }

        return (
            <FormGroup className="additional-labor-job-resource-manager">
                <FormLabel
                    htmlFor="additionalJobResourceApplicationUserGroups"
                    text={`Additional Labor - ${this.getEventDisplayDate()}`}
                />
                <ValidatedSelect
                    name="additionalJobResourceApplicationUserGroups"
                    options={applicationUserGroups}
                    getOptionValue={(aug) => aug.id}
                    getOptionLabel={(aug) => aug.groupName}
                    isMulti
                    value={
                        applicationUserGroups.filter((et) =>
                            additionalLaborResources.some(
                                (ajr) => ajr.applicationUserGroupId == et.id
                            )
                        ) ?? ''
                    }
                    onChange={this.onApplicationUserGroupSelectionChange}
                    hideClear
                />

                {additionalLaborResources.map((ajr, i) => {
                    const applicationUserGroup = applicationUserGroups.find(
                        (et) => et.id == ajr.applicationUserGroupId
                    );

                    if (!applicationUserGroup) {
                        return null;
                    }

                    return (
                        <InputGroup
                            key={ajr.applicationUserGroupId}
                            className="mt-2"
                        >
                            <InputGroupText>
                                {applicationUserGroup.groupName}
                            </InputGroupText>

                            <Input
                                value={ajr.count}
                                className={cls({
                                    invalid: !ajr.count,
                                })}
                                onChange={this.onCountChange.bind(this, {
                                    applicationUserGroupId:
                                        ajr.applicationUserGroupId,
                                })}
                                invalid={
                                    !ajr.count || ajr.count > MaxResourceCount
                                }
                            />
                        </InputGroup>
                    );
                })}
            </FormGroup>
        );
    }
}
